<template>
  <div class="citic-table-list">
    <!-- <el-select
      v-if="status !== 'pending'"
      v-model="reviewStatus"
      placeholder="请选择"
      @change="handleReviewStatusChange"
    >
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
      </el-option>
    </el-select> -->

    <!-- 点评中的基础数据入库 -->
    <el-tabs v-if="status === 'pending'" v-model="activeName" @tab-click="handleClick">
      <el-tab-pane
        label="待处理"
        name="0"
      >
        <!-- 待处理点评列表 -->
        <el-table
          v-if="status === 'pending'"
          ref="dataTable"
          :data="lists_unbsae"
          v-loading="loading"
          style="width: 100%"
          class="post_table"
          height="600"
        >
          <el-table-column
            type="selection"
            width="30"
          ></el-table-column>
          <el-table-column
            label="点评时间"
            width="180"
          >
            <template slot-scope="scope">
              {{scope.row.time_created / 1000 | datetime}}
            </template>
          </el-table-column>
          <el-table-column
            prop="productname"
            label="产品名称"
            width="180"
          >
          </el-table-column>
          <el-table-column label="新增产品">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.has_new_product | boolMapper}}</span>
            </template>
          </el-table-column>
          <el-table-column label="新增类别">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.has_new_category | boolMapper}}</span>
            </template>
          </el-table-column>
          <el-table-column label="新增厂商简称">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.has_new_company_alias | boolMapper}}</span>
            </template>
          </el-table-column>
          <el-table-column label="新增产品-类别关系">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.has_new_category_product_relation | boolMapper}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            align="center"
            width="150"
          >
            <template slot-scope="scope">
              <el-button
                size="small"
                type="primary"
                @click.prevent.stop="handleEngage(scope.row)"
              >马上处理</el-button>
            </template>
          </el-table-column>
          <el-table-column
            label="状态"
            align="center"
            width="150"
          >
            <template slot-scope="scope">
              <el-button
                size="small"
                type="primary"
                @click="handleIsprocessed(scope.row)"
              >忽略</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="table-list__footer">
          <el-pagination
            @current-change="handlePageChange"
            :current-page="page"
            :page-size="pageSizeOne"
            layout="total, prev, pager, next, jumper"
            :total="totalOne"
          >
          </el-pagination>
        </div>
      </el-tab-pane>
      <el-tab-pane
        label="已忽略"
        name="1"
      >
        <!-- 待处理点评列表 -->
        <el-table
          v-if="status === 'pending'"
          ref="dataTable"
          :data="lists_base"
          v-loading="loading"
          style="width: 100%"
          class="post_table"
          height="600"
        >
          <el-table-column
            type="selection"
            width="30"
          ></el-table-column>
          <el-table-column
            label="点评时间"
            width="180"
          >
            <template slot-scope="scope">
              {{scope.row.time_created / 1000 | datetime}}
            </template>
          </el-table-column>
          <el-table-column
            prop="productname"
            label="产品名称"
            width="180"
          >
          </el-table-column>
          <el-table-column label="新增产品">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.has_new_product | boolMapper}}</span>
            </template>
          </el-table-column>
          <el-table-column label="新增类别">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.has_new_category | boolMapper}}</span>
            </template>
          </el-table-column>
          <el-table-column label="新增厂商简称">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.has_new_company_alias | boolMapper}}</span>
            </template>
          </el-table-column>
          <el-table-column label="新增产品-类别关系">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.has_new_category_product_relation | boolMapper}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            align="center"
            width="150"
          >
            <template slot-scope="scope">
              <el-button
                size="small"
                type="primary"
                @click.prevent.stop="handleEngage(scope.row)"
              >马上处理</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="table-list__footer">
          <el-pagination
            @current-change="handlePageChange"
            :current-page="page"
            :page-size="pageSizeTwo"
            layout="total, prev, pager, next, jumper"
            :total="totalTwo"
          >
          </el-pagination>
        </div>
      </el-tab-pane>
    </el-tabs>
    
    <el-tabs v-else-if="status === 'stored'" v-model="activeName" @tab-click="handleClick">
      <el-tab-pane
        label="待审核"
        name="0"
      >
        <el-table
          ref="dataTable"
          :data="lists_unreviews"
          v-loading="loading"
          style="width: 100%"
          class="post_table"
          height="600"
        >
          <el-table-column
            type="selection"
            width="30"
          ></el-table-column>
          <el-table-column
            label="点评时间"
            width="180"
          >
            <template slot-scope="scope">
              {{scope.row.time_created / 1000 | datetime}}
            </template>
          </el-table-column>
          <el-table-column
            prop="productname"
            label="产品名称"
            width="180"
          >
          </el-table-column>
          <el-table-column label="类别">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.categoryname }}</span>
            </template>
          </el-table-column>
          <el-table-column label="厂商简称">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.factoryname }}</span>
            </template>
          </el-table-column>
          <el-table-column label="口碑指数">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.score }}</span>
            </template>
          </el-table-column>
          <el-table-column label="优点">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.pros }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            align="center"
            width="150"
          >
            <template slot-scope="scope">
              <el-button
                size="small"
                type="primary"
                @click.prevent.stop="handleUpdate(scope.row)"
              >马上审核</el-button>
            </template>
          </el-table-column>
          <!-- <el-table-column label="状态">
            <template slot-scope="scope">
              <el-button type="info" size="small" @click="handleIsreviewe(scope.row)">马上审核</el-button>
            </template>
          </el-table-column> -->
        </el-table>
        <div class="table-list__footer">
          <el-pagination
            @current-change="handlePageChange"
            :current-page="page"
            :page-size="pageSizeThree"
            layout="total, prev, pager, next, jumper"
            :total="totalThree"
          >
          </el-pagination>
        </div>
      </el-tab-pane>
      <el-tab-pane
        label="已审核"
        name="1"
      >
        <el-select
      v-model="reviewStatus"
      placeholder="请选择"
      @change="handleReviewStatusChange"
      style="margin-top:20px;margin-bottom:20px"
    >
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
      </el-option>
    </el-select>
        <el-table
          ref="dataTable"
          :data="lists_reviews"
          v-loading="loading"
          style="width: 100%"
          class="post_table"
          height="600"
        >
          <el-table-column
            type="selection"
            width="30"
          ></el-table-column>
          <el-table-column
            label="点评时间"
            width="180"
          >
            <template slot-scope="scope">
              {{scope.row.time_created / 1000 | datetime}}
            </template>
          </el-table-column>
          <el-table-column
            prop="productname"
            label="产品名称"
            width="180"
          >
          </el-table-column>
          <el-table-column label="类别">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.categoryname }}</span>
            </template>
          </el-table-column>
          <el-table-column label="厂商简称">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.factoryname }}</span>
            </template>
          </el-table-column>
          <el-table-column label="口碑指数">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.score }}</span>
            </template>
          </el-table-column>
          <el-table-column label="优点">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.pros }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="点评打钱"
            align="center"
            width="150"
          >
            <template slot-scope="scope">
              <el-button
                size="small"
                type="primary"
                @click.prevent.stop="handleMoney(scope.row)"
                v-if="scope.row.ismakemoney === '1'"
                disabled
              >已打钱</el-button>
              <el-button
                size="small"
                type="primary"
                @click.prevent.stop="handleMoney(scope.row)"
                v-if="scope.row.ismakemoney === '0'"
              >打钱</el-button>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            align="center"
            width="150"
          >
            <template slot-scope="scope">
              <el-button
                size="small"
                type="primary"
                @click.prevent.stop="handleUpdate(scope.row)"
              >马上处理</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="table-list__footer">
          <el-pagination
            @current-change="handlePageChange"
            :current-page="page"
            :page-size="pageSizeFour"
            layout="total, prev, pager, next, jumper"
            :total="totalFour"
          >
          </el-pagination>
        </div>
      </el-tab-pane>
    </el-tabs>
    <el-tabs v-else v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="待处理" name="0">
        <el-table
          ref="dataTable"
          :data="lists_unsmart"
          v-loading="loading"
          style="width: 100%"
          class="post_table"
          height="600"
        >
          <el-table-column
            type="selection"
            width="30"
          ></el-table-column>
          <el-table-column
            label="点评时间"
            width="180"
          >
            <template slot-scope="scope">
              {{scope.row.time_created / 1000 | datetime}}
            </template>
          </el-table-column>
          <el-table-column
            prop="productname"
            label="产品名称"
            width="180"
          >
          </el-table-column>
          <el-table-column label="类别">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.categoryname }}</span>
            </template>
          </el-table-column>
          <el-table-column label="厂商简称">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.factoryname }}</span>
            </template>
          </el-table-column>
          <el-table-column label="口碑指数">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.ztgsnum }}</span>
            </template>
          </el-table-column>
          <el-table-column label="优点">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.advantages }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            align="center"
            width="150"
          >
            <template slot-scope="scope">
              <el-button
                size="small"
                type="primary"
                @click.prevent.stop="hendleSmart(scope.row)"
              >马上处理</el-button>
            </template>
          </el-table-column>
          <!-- <el-table-column label="状态">
            <template slot-scope="scope">
              <el-button type="info" size="small" @click="handleIsreviewe(scope.row)">马上审核</el-button>
            </template>
          </el-table-column> -->
        </el-table>
        <div class="table-list__footer">
          <el-pagination
            @current-change="handlePageChange"
            :current-page="page"
            :page-size="pageSizeFive"
            layout="total, prev, pager, next, jumper"
            :total="totalFive"
          >
          </el-pagination>
        </div>
      </el-tab-pane>
      <el-tab-pane label="已处理" name="1">
        <el-table
          ref="dataTable"
          :data="lists_smart"
          v-loading="loading"
          style="width: 100%"
          class="post_table"
          height="600"
        >
          <el-table-column
            type="selection"
            width="30"
          ></el-table-column>
          <el-table-column
            label="点评时间"
            width="180"
          >
            <template slot-scope="scope">
              {{scope.row.time_created / 1000 | datetime}}
            </template>
          </el-table-column>
          <el-table-column
            prop="productname"
            label="产品名称"
            width="180"
          >
          </el-table-column>
          <el-table-column label="类别">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.categoryname }}</span>
            </template>
          </el-table-column>
          <el-table-column label="厂商简称">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.factoryname }}</span>
            </template>
          </el-table-column>
          <el-table-column label="口碑指数">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.ztgsnum }}</span>
            </template>
          </el-table-column>
          <el-table-column label="优点">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.advantages }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            align="center"
            width="150"
          >
            <template slot-scope="scope">
              <el-button
                size="small"
                type="primary"
                @click.prevent.stop="hendleSmart(scope.row)"
              >马上处理</el-button>
            </template>
          </el-table-column>
          <!-- <el-table-column label="状态">
            <template slot-scope="scope">
              <el-button type="info" size="small" @click="handleIsreviewe(scope.row)">马上审核</el-button>
            </template>
          </el-table-column> -->
        </el-table>
        <div class="table-list__footer">
          <el-pagination
            @current-change="handlePageChange"
            :current-page="page"
            :page-size="pageSizeSix"
            layout="total, prev, pager, next, jumper"
            :total="totalSix"
          >
          </el-pagination>
        </div>
      </el-tab-pane>
    </el-tabs>

    <!-- Slide content -->
    <TheSlideBox
      name="reivew-detail-panel"
      :visible="shouldShowDetailPanel"
      @close="closeDetailPanel"
    >
      <detail
        v-if="status === 'pending' && shouldShowDetailPanel"
        :reviewId="currentReviewId"
        :reviewStatus="currentReviewStatus"
        @statusUpdate="handleReviewStatusUpdate"
        @finished="handleFinished"
      ></detail>
      <edit
        v-if="status === 'stored' && shouldShowDetailPanel"
        :reviewId="currentReviewId"
      ></edit>
      <smart
        v-if="status === 'analysis' && shouldShowDetailPanel"
        :reviewId="currentReviewId"
        :categoryId = "currentCategoryId"
      ></smart>
    </TheSlideBox>
  </div>
</template>

<script>
import axios from 'axios'
import TheSlideBox from '../../partials/TheSlideBox'
import detail from './Detail'
import edit from './Edit'
import smart from './Smart'

export default {
  name: 'ContainerList',
  components: {
    TheSlideBox,
    detail,
    edit,
    smart
  },
  props: ['isActivated', 'status'],
  data () {
    return {
      activeName: '0',
      loading: false,
      lists_unbsae: [],
      lists_base: [],
      lists_unreviews: [],
      lists_reviews: [],
      lists_unsmart: [],
      lists_smart: [],
      currentPage: 1,
      pageSizeTwo: 10,
      pageSizeOne: 10,
      pageSizeThree: 10,
      pageSizeFour: 10,
      pageSizeFive: 10,
      pageSizeSix: 10,
      totalOne: 0,
      totalTwo: 0,
      totalThree: 0,
      totalFour: 0,
      totalSix: 0,
      totalFive: 0,
      reviewStatus: 0,
      currentReviewId: null,
      currentCategoryId: null,
      currentReviewStatus: null,
      options: [{
        value: 0,
        label: '有价值'
      }, {
        value: 1,
        label: '无价值'
      }, {
        value: 2,
        label: '疑似厂商点评'
      }]
    }
  },
  computed: {
    shouldShowSingleDeleteConfirm () {
      return this.itemToDelete.item !== null
    },
    shouldEnableFooterActions () {
      return this.posts.multipleSelected.length > 0
    },
    shouldShowDetailPanel () {
      return this.currentReviewId !== null
    }
  },
  filters: {
    boolMapper (val) {
      if (val === 'true') {
        return '新增'
      } else {
        return '现有'
      }
    }
  },
  methods: {
    // 马上打钱
    handleMoney (scope) {
      let url = this.$config.API.getMoney.add
      let data = {
        score_id: scope.review_id
      }
      axios.post(url, data).then(res => {
        this.fetchData_review('1')
        console.log(res)
      })
    },
    // 忽略
    handleIsprocessed (scope) {
      console.log('scope', scope.review_id)
      let url = this.$config.API.reviews.isprocessed
      let data = {
        score_id: scope.review_id,
        is_processed: '1'
      }
      axios.post(url, data).then(res => {
        // console.log(1, id)
        this.fetchData(this.activeName)
      }).catch(err => {
        console.log(err)
        this.loading = false
      })
    },
    // 处理状态
    // handleIsreviewe (scope) {
    //   console.log('scope', scope.review_id)
    //   let url = this.$config.API.reviews.isreviewed
    //   let data = {
    //     score_id: scope.review_id,
    //     // is_reviewed: this.activeName
    //     is_reviewed: '1'
    //   }
    //   axios.post(url, data).then(res => {
    //     // console.log(1, id)
    //     this.fetchData_review(this.activeName)
    //   }).catch(err => {
    //     console.log(err)
    //     this.loading = false
    //   })
    // },
    handleClick (tab, event) {
      console.log(tab, event)
      console.log(111)
      this.fetchData()
      this.fetchData_review()
      this.fetchData_analysis()
    },
    handleSelectionChange (val) {
      this.posts.multipleSelected = val
    },
    handlePageChange (page) {
      this.currentPage = page
      this.fetchData()
      this.fetchData_review()
      this.fetchData_analysis()
    },
    // VIEW:
    closeDetailPanel () {
      this.currentReviewId = null
      // this.$refs.dataTable.setCurrentRow(null)
    },
    fillAndCheck (row) {
      let url = this.$config.API.reviews.fillAndCheck
      return new Promise((resolve, reject) => {
        axios.post(url, {
          review_id: row.review_id
        }).then(res => {
          switch (res.status) {
            case 200: // 需要人工做入库处理
              this.currentReviewStatus = res.data.data
              this.currentReviewId = row.review_id
              break
            case 204: // 检查通过，项目直接消失
              // console.log(this.currentReviewId)
              this.handleFinished(row.review_id)
              this.currentReviewStatus = null
              this.currentReviewId = null
              break
          }
          resolve(res)
        }).catch(err => {
          console.log(err)
          switch (err.response.status) {
            case 400:
              this.$message.error('未找到该条点评信息')
              break
            case 500:
              this.$message.error('操作失败')
          }
        })
      })
    },
    // 智能分析功能列表根据id查询
    fillSmartList (row) {
      let url = this.$config.API.reviews.capacityFind
      let params = {
        score_id: row.review_id
      }
      axios.get(url, {params}).then(res => {
        this.currentReviewId = row.review_id
        this.currentCategoryId = row.category_id
        console.log(res)
      })
    },
    fetchData () {
      let url = null
      if (this.status === 'pending') {
        url = this.$config.API.reviews.listPending
      }
      this.loading = true
      axios.get(url, {
        params: {
          page: this.currentPage,
          // status: this.reviewStatus,
          is_processed: this.activeName
        }
      }).then(res => {
        if (this.activeName === '0') {
          this.lists_unbsae = res.data.review_list
          this.pageSizeOne = res.data.page_size
          this.totalOne = res.data.total
        } else {
          this.lists_base = res.data.review_list
          this.pageSizeTwo = res.data.page_size
          this.totalTwo = res.data.total
        }
        this.loading = false
      }).catch(err => {
        console.log(err)
        this.loading = false
      })
    },
    // 点评管理
    fetchData_review () {
      let url = this.$config.API.reviews.listStored
      this.loading = true
      axios.get(url, {
        params: {
          page: this.currentPage,
          status: this.reviewStatus,
          is_reviewed: this.activeName
        }
      }).then(res => {
        if (this.activeName === '1') {
          this.lists_reviews = res.data.review_list
          this.pageSizeFour = res.data.page_size
          this.totalFour = res.data.total
        }
        this.loading = false
      }).catch(err => {
        console.log(err)
        this.loading = false
      })
      axios.get(url, {
        params: {
          page: this.currentPage,
          status: 1,
          is_reviewed: this.activeName
        }
      }).then(res => {
        if (this.activeName === '0') {
          this.lists_unreviews = res.data.review_list
          this.pageSizeThree = res.data.page_size
          this.totalThree = res.data.total
        }
        this.loading = false
      }).catch(err => {
        console.log(err)
        this.loading = false
      })
    },
    // 点评智能分析处理
    fetchData_analysis () {
      let url = null
      if (this.status === 'analysis') {
        url = this.$config.API.reviews.capacityList
      }
      let params = {
        page: this.currentPage,
        is_handle: this.activeName
      }
      axios.get(url, {params}).then(res => {
        if (this.activeName === '0') {
          this.lists_unsmart = res.data.handleList
          this.pageSizeFive = res.data.page_size
          this.totalFive = res.data.total
        } else {
          this.lists_smart = res.data.handleList
          this.pageSizeSix = res.data.page_size
          this.totalSix = res.data.total
        }
      })
    },
    handleEngage (row) {
      this.fillAndCheck(row)
    },
    hendleSmart (row) {
      this.fillSmartList(row)
    },
    handleUpdate (row) {
      this.currentReviewId = row.review_id
      this.currentCategoryId = row.category_id
    },
    handleReviewStatusUpdate (status) {
      this.currentReviewStatus = status
    },
    handleFinished (reviewId) {
      this.lists = this.lists.filter(item => {
        return item.review_id !== reviewId
      })
    },
    handleReviewStatusChange (value) {
      this.reviewStatus = value
      // this.fetchData()
      this.fetchData_review()
    }
  },
  watch: {
    isActivated: function (val, preVal) {
      if (val) {
        this.fetchData()
        this.fetchData_review()
        this.fetchData_analysis()
      }
    }
  },
  mounted () {
    this.$emit('loaded', this.status)
    // this.fetchData()
    console.log(this.status)
    // this.fetchData_analysis()
  }
}
</script>

<style lang="scss">
.citic-table-list {
  .post_table .columns {
    font-size: 12px;
    color: #333;
    div {
      display: inline-block;
      width: auto;
    }
    div.headline {
      width: 20%;
    }
  }
  .table-list__filters,
  .table-list__filters .date-range {
    display: flex;
    align-items: center;
    & > * {
      margin-right: 10px;
    }
  }
  .table-list__toolbar {
    position: absolute;
    top: 18px;
    right: 30px;
    .el-button-group {
      button {
        padding-right: 5px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// List.vue?64d61018